import React, { useCallback } from 'react';
import { EChartsWrapper } from './echarts-wrapper';
import { createBarChartOption, type ChartViewport } from '../lib/chart-options';
import type { TopItemsData } from '@/entities/dashboard';
import type { ExportOptions, ChartExportOptions } from '@/shared/lib/export';

interface BarChartProps {
  data?: TopItemsData;
  height?: number | string;
  className?: string;
  loading?: boolean;
  showExport?: boolean;
  exportOptions?: {
    png?: ChartExportOptions;
    csv?: ExportOptions;
    xlsx?: ExportOptions;
  };
  exportPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const EMPTY_DATA: TopItemsData = { series: [] };

export const BarChart: React.FC<BarChartProps> = ({
  data,
  height,
  className,
  loading,
  showExport,
  exportOptions,
  exportPosition
}) => {
  const buildOption = useCallback(
    (viewport: ChartViewport) => createBarChartOption(data || EMPTY_DATA, viewport),
    [data]
  );

  return (
    <EChartsWrapper
      option={buildOption}
      height={height}
      className={className}
      loading={loading}
      showExport={showExport}
      exportOptions={exportOptions}
      exportPosition={exportPosition}
    />
  );
};
